import React from "react";
import { Grid } from "@mui/material";
import { farmers } from "../../config/images";
import translations from "../../config/language";

const PersonalDetails = ({ selectedFarmer }) => {
    const [firstName, middleName, lastName] = selectedFarmer.farmerName.split(" ");

    const language = process.env.REACT_APP_LANGUAGE
    return (
        <div className="user-profile" >
            <Grid container spacing={2}>
                <Grid item lg={8} xs={12}>
                    <Grid container>
                        <Grid item lg={4} xs={12} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", paddingLeft:"20px"}}
                        >{translations[language].firstName}
                        </Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                            {firstName}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].middleName}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{fontWeight: 700}}>{middleName}</Grid>
                    </Grid>
                    <Grid container>
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].lastName}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{fontWeight: 700}}>{lastName}</Grid>
                    </Grid>
                    <Grid container>
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].gender}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{fontWeight: 700}}>{translations[language].male}</Grid>
                    </Grid>
                    <Grid container>
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].dateOfBirth}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item">
                            <div style={{ display: "flex", gap: "10px", fontWeight: 700 }}>
                                <div style={{ paddingRight: "20px", borderRight: "1px solid  #D9D9D9" }}>15/01/2000</div>
                                <div style={{ paddingLeft: "20px" }}>25 years</div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].mobileNumber}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{fontWeight: 700}}>
                            {selectedFarmer.mobileNumber}
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].alternateMobileNumber}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{fontWeight: 700}}>
                            +234 9876 5432
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].email}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{fontWeight: 700}}>
                            jones_scott@gmail.com
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid item lg={4} xs={12} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].nationalIdentificationNo}</Grid>
                        <Grid item lg={8} xs={12} className="grid-item" style={{fontWeight: 700}}>
                            13478900923
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item lg={4}>
                    <img src={farmers.farmerDetailsImage} alt="Farmer" className="user-image" />
                </Grid>
            </Grid>
        </div>
    );
};

export default PersonalDetails;
